export default {
  header: '我的頁面',
  changePassword: {
    header: '更改密碼',
    oldPassword: '原有密碼',
    newPassword: '新密碼',
    confirmNewPassword: '確認新密碼',
    changePassword: '更改密碼',
  },

  profile: {
    language: '系統語言',
    header: '我的檔案',
    personalInformation: '個人資料',
    chineseName: '中文名稱',
    englishName: 'English Name',
    agentCode: '顧問編號',
    contactInformation: '聯絡資料',
    licenseInformation: {
      header: '牌照資料',
      oci: {
        header: '保監相關',
        ociLicensePrinciples: '保險原理及實務',
        ociLicenseGeneral: '一般保險',
        ociLicenseLongTerm: '長期保險',
        ociLicenseLinkedLongTerm: '投資相連長期保險',
        ociLicenseTravel: '旅遊保險代理人',
      },
      sfc: {
        header: '證監相關',
        sfcLicenseType1: '一類',
        sfcLicenseType2: '二類',
        sfcLicenseType3: '三類',
        sfcLicenseType4: '四類',
        sfcLicenseType5: '五類',
        sfcLicenseType6: '六類',
        sfcLicenseType7: '七類',
        sfcLicenseType8: '八類',
        sfcLicenseType9: '九類',
        sfcLicenseType10: '十類'
      }
    }

  }
}


// WEBPACK FOOTER //
// ./src/My/langs/zh_hk/index.js